import {
    GET_OBJECT_SELECTED,
    UPDATE_OBJECT_SELECTED,
    APP_LOADED,
} from './actionTypes';
import { getUserFeatures } from '../../../feature-toggle/feature-toggle.state';

export const updateObjectSelected = objectSelected => ({
    type: UPDATE_OBJECT_SELECTED,
    objectSelected,
});

export const getObjectSelected = objectSelected => ({
    type: GET_OBJECT_SELECTED,
    objectSelected,
});

export const fetchUserFeatures = () => (dispatch) => {
    dispatch(getUserFeatures());
};

export const dispatchAppLoaded = () => ({
    type: APP_LOADED,
    payload: {},
});
